import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Button, Form, Modal } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { TaskModel, TaskToDeleteModel } from "@teamprevent/common/task/taskActions/models";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { ApplicationState } from "../../applicationState";
import { DELETE_TASK } from "../../crud/ohCase/actiontypes";
import { deleteTask } from "../../crud/ohCase/actions";

interface Props {
    task: TaskModel;
}

export const DeleteTaskButton: React.FunctionComponent<Props> = (props: Props) => {
    const dispatch = useDispatch();

    const [modalOpen, setModalOpen] = React.useState<boolean>(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);
    const [comments, setComments] = React.useState<string>(null);

    const customerId = useSelector((state: ApplicationState) => state.router.params.customerId);
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params.ohCaseId);

    const onDelete = React.useCallback(() => setModalOpen(true), [props.task]);

    const onCancel = React.useCallback(() => resetState(), [props.task]);

    const resetState = () => {
        setModalOpen(false);
        setSubmitted(false);
        setComments(null);
    };

    const onDeleteConfirm = React.useCallback(
        () => {
            setSubmitted(true);
            if (!comments) {
                return;
            }
            const model: TaskToDeleteModel = {
                taskId: props.task.id,
                comments
            };
            dispatch(deleteTask(customerId, ohCaseId, model));
            setModalOpen(false);
        },
        [props.task, comments]
    );

    const onCommentsChange = React.useCallback((newComments: string) => setComments(newComments), [props.task]);

    return (
        <>
            <Modal open={modalOpen}>
                <Modal.Header content={`Delete "${props.task.description}" task?`} />
                <Modal.Content>
                    <Form>
                        <Input.Textarea
                            required
                            value={comments}
                            showErrors={submitted}
                            label="Comments"
                            onChange={onCommentsChange}
                        />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={onCancel} />
                    <Button className="warning" content="Delete" onClick={onDeleteConfirm} />
                </Modal.Actions>
            </Modal>
            <IsLoadingButton
                basic
                icon="delete"
                className="red"
                size="mini"
                floated="right"
                onClick={onDelete}
                requestNames={DELETE_TASK}
            />
        </>
    );
};
